import _ from 'lodash';
import { useTranslation } from 'react-i18next';

import { useLocalize } from '@treams/treams-hooks';
import * as graphql from '@treams/treams-network';

import EmployeesFilter from '../EmployeesFilter';

export default function EmployeesJobFilter() {
	const { t } = useTranslation();
	const { localize } = useLocalize();

	const query = graphql.useJobTitlesQuery({
		variables: {
			isArchived: false,
			first: 1000,
		},
	});

	return (
		<EmployeesFilter
			label={t('employees.filters.jobs.label')}
			name="jobTitleIDs"
			options={[
				..._.sortBy(
					query.data?.jobTitles.edges.map(({ node }) => ({
						label: localize(node.title).text,
						value: node.id,
					})) ?? [],
					'label',
				),
				{
					label: t('employees.filters.jobs.without'),
					value: '0',
				},
			]}
		/>
	);
}
